import BaseService from './base.service';

const baseService = new BaseService('mdDiagnosticoPreguntaCountry', process.env.VUE_APP_BEEREADERS_API_URL);

export interface VariantAnswer {
  item: number;
  contenido: string;
}

export interface CreateVariantDTO {
  preguntaId: number;
  countryCode: string;
  contenido: string;
  respuestas: VariantAnswer[];
}

export interface UpdateVariantDTO {
  contenido?: string;
  respuestas?: VariantAnswer[];
}

export interface UpdateOriginalQuestionDTO {
  contenido: string;
  respuestas: VariantAnswer[];
  lbAimOfassessmentId?: number;
  respuestaCorrecta?: number;
}

export interface AimOfAssessmentDTO {
  id: number;
  code: string;
  detail: string;
  measuredAspect?: string;
  subCode?: string;
}

export default {
  /**
   * Get variant status for a diagnostic (which countries have variants)
   */
  getVariantStatus: (diagnosticoId: number) => baseService.get('getVariantStatus', {
    params: { diagnosticoId },
  }),

  /**
   * Get all variants for a specific diagnostic and country
   * @param diagnosticoId - Diagnostic test ID
   * @param countryCode - Country code (USA, PER)
   */
  getVariantsByDiagnostico: (diagnosticoId: number, countryCode: string) => baseService.get('getVariantsByDiagnostico', {
    params: { diagnosticoId, countryCode },
  }),

  /**
   * Create or update a country variant
   */
  createVariant: (data: CreateVariantDTO) => baseService.post('create', data),

  /**
   * Update an existing variant
   */
  updateVariant: (id: number, data: UpdateVariantDTO) => baseService.put(`update/${id}`, data),

  /**
   * Update original (general) diagnostic question
   */
  updateOriginalQuestion: (
    preguntaId: number,
    data: UpdateOriginalQuestionDTO,
  ) => baseService.put(`updateOriginal/${preguntaId}`, data),

  /**
   * Get active skills (aim of assessment) for general edition
   */
  getAimOfAssessments: () => baseService.get('aimOfAssessments'),
};
